function getSlugOfMissingRequiredSettings(id: number) {
  return `integration-${id}-missing-required-settings`;
}

export { getSlugOfMissingRequiredSettings };
